import { Component, Input } from '@angular/core';
import { ProfileSectionModel } from '../../../../../Discover/Targeting/models/profile-section.model';

@Component({
    selector: 'agpr-entity-profile-section',
    templateUrl: './profile-section.component.html',
    styleUrls: ['./profile-section.component.scss'],
    standalone: false
})
export class ProfileSectionComponent {
    public arrayClass = Array;
    @Input() profileSection: ProfileSectionModel;
}
